<template>
    <ul class="iq-timeline">
        <li v-for="(item,index) in items" :key="index">
            <div class="timeline-dots" :class="'border-'+item.package.color_variant"></div>
            <h5 class="float-left mb-1" v-html="item.package.parentPackage.name + ' ' + item.package.name"></h5>
            <small class="float-right mt-1" v-html="new Date(item.cTimestamp).toLocaleString()"></small>
            <div class="d-inline-block w-100">
                <p class="m-0" v-html="item.paypal_subscription_id"></p>
            </div>
            <div class="d-inline-block w-100">
                <h6 class="float-left mb-1" v-html="item.status" :style="'color:' + statusColor(item.status) "></h6>
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'TimeLine',
    props: {
        items: {type: Array, default: () => []}
    },
    methods: {
        statusColor(status) {
            if (status === 'CONFIRMED') {
                return 'green';
            } else if (status === 'OVERRIDDEN') {
                return '#DAA520';
            } else {
                return 'red';
            }
        }
    }
}
</script>
